import script from "./DuaSai.vue?vue&type=script&setup=true&lang=js"
export * from "./DuaSai.vue?vue&type=script&setup=true&lang=js"

import "./DuaSai.vue?vue&type=style&index=0&id=35b95f03&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b95f03"]])

export default __exports__